const actions = {
  FETCH_LOCAL_SERVICES: 'FETCH_LOCAL_SERVICES',
  FETCH_LOCAL_SERVICES_SUCCESS: 'FETCH_LOCAL_SERVICES_SUCCESS',
  FETCH_LOCAL_SERVICES_ERROR: 'FETCH_LOCAL_SERVICES_ERROR',
  REQUEST_SERVICE_LOG: 'REQUEST_SERVICE_LOG',
  REQUEST_SERVICE_LOG_ERROR: 'REQUEST_SERVICE_LOG_ERROR',
  DOWNLOAD_SERVICE_LOG: 'DOWNLOAD_SERVICE_LOG',
  DOWNLOAD_SERVICE_LOG_SUCCESS: 'DOWNLOAD_SERVICE_LOG_SUCCESS',
  DOWNLOAD_SERVICE_LOG_ERROR: 'DOWNLOAD_SERVICE_LOG_ERROR',
  FETCH_LOCAL_SERVICE_PHARMACY: 'FETCH_LOCAL_SERVICE_PHARMACY',
  FETCH_LOCAL_SERVICE_PHARMACY_SUCCESS: 'FETCH_LOCAL_SERVICE_PHARMACY_SUCCESS',
  FETCH_LOCAL_SERVICE_PHARMACY_ERROR: 'FETCH_LOCAL_SERVICE_PHARMACY_ERROR',
  LOCAL_SERVICE_PHARMACY_UPDATE: 'LOCAL_SERVICE_PHARMACY_UPDATE',
  LOCAL_SERVICE_PHARMACY_UPDATE_SUCCESS: 'LOCAL_SERVICE_PHARMACY_UPDATE_SUCCESS',
  LOCAL_SERVICE_PHARMACY_UPDATE_ERROR: 'LOCAL_SERVICE_PHARMACY_UPDATE_ERROR',
  FETCH_LOCAL_SERVICE_PHARMACIES: 'FETCH_LOCAL_SERVICE_PHARMACIES',
  FETCH_LOCAL_SERVICE_PHARMACIES_SUCCESS: 'FETCH_LOCAL_SERVICE_PHARMACIES_SUCCESS',
  FETCH_LOCAL_SERVICE_PHARMACIES_ERROR: 'FETCH_LOCAL_SERVICE_PHARMACIES_ERROR',
  DOWNLOAD_SERVICE_CONFIG: 'DOWNLOAD_SERVICE_CONFIG',
  DOWNLOAD_SERVICE_CONFIG_SUCCESS: 'DOWNLOAD_SERVICE_CONFIG_SUCCESS',
  DOWNLOAD_SERVICE_CONFIG_ERROR: 'DOWNLOAD_SERVICE_CONFIG_ERROR',
  CREATE_LOCAL_SERVICE: 'CREATE_LOCAL_SERVICE',
  CREATE_LOCAL_SERVICE_SUCCESS: 'CREATE_LOCAL_SERVICE_SUCCESS',
  CREATE_LOCAL_SERVICE_ERROR: 'CREATE_LOCAL_SERVICE_ERROR',
  FETCH_UNRESOLVED_EVENTS: 'FETCH_UNRESOLVED_EVENTS',
  FETCH_UNRESOLVED_EVENTS_SUCCESS: 'FETCH_UNRESOLVED_EVENTS_SUCCESS',
  FETCH_UNRESOLVED_EVENTS_ERROR: 'FETCH_UNRESOLVED_EVENTS_ERROR',
  fetchLocalServices: () => ({
    type: actions.FETCH_LOCAL_SERVICES,
  }),
  requestLog: (id) => ({
    type: actions.REQUEST_SERVICE_LOG,
    id,
  }),
  downloadLog: (id) => ({
    type: actions.DOWNLOAD_SERVICE_LOG,
    id,
  }),
  fetchLocalServicePharmacy: (pharmacyId) => ({
    type: actions.FETCH_LOCAL_SERVICE_PHARMACY,
    pharmacyId,
  }),
  updatePharmacySettings: (pharmacyId, payload) => ({
    type: actions.LOCAL_SERVICE_PHARMACY_UPDATE,
    pharmacyId,
    payload,
  }),
  fetchPharmacies: () => ({
    type: actions.FETCH_LOCAL_SERVICE_PHARMACIES,
  }),
  downloadConfigFile: (id) => ({
    type: actions.DOWNLOAD_SERVICE_CONFIG,
    id,
  }),
  createLocalService: (id) => ({
    type: actions.CREATE_LOCAL_SERVICE,
    id,
  }),
  fetchUnresolvedEvents: () => ({
    type: actions.FETCH_UNRESOLVED_EVENTS,
  }),
};
export default actions;
